import { logger } from "@/utils/log";

export const handleDirectChange = (config) => {
		const { tabList, column = 1, line = 1, firstGridIndex = 0, e } = config;
		const { keyCode } = e;
    let nextIndex, currentIndex;
    if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
      currentIndex = Array.prototype.indexOf.call(tabList, e.target);
    } else {
      return;
    }
    if (keyCode === 37) {
      // left
      if (currentIndex === firstGridIndex) {
        nextIndex = tabList.length - 1;
      } else {
        nextIndex = currentIndex - 1;
      }
    } else if (keyCode === 39) {
      // right
      if (currentIndex < tabList.length - 1) {
        nextIndex = currentIndex + 1;
      } else {
        nextIndex = firstGridIndex;
      }
    }else if(keyCode === 40){
      // down
      if (currentIndex + column < tabList.length) {
        nextIndex = currentIndex + column;
      } else {
        nextIndex = currentIndex === tabList.length - 1 ? firstGridIndex: currentIndex - column*(line-1) + 1;
      }
    }else if(keyCode === 38){
      // up
      if (currentIndex  >= column) {
        nextIndex = currentIndex - column;
      } else {
        nextIndex = currentIndex === firstGridIndex ? tabList.length-1: currentIndex + column*(line-1) - 1;
      }
    }
    tabList[nextIndex].focus();
}

export const initDirectChange = ( table ) => {
  try{
    // Validate table element
    if (!table || !table.querySelectorAll) {
      logger.warn('initDirectChange: Invalid table element provided');
      return;
    }

    const tabList = table.querySelectorAll(`tr > td`) || []
    const line = table.querySelectorAll(`tr`).length || 1
    const column = Math.ceil(tabList.length / line)
    const config = {tabList,line,column}

    // Only proceed if we have valid tabList
    if (tabList.length === 0) {
      logger.warn('initDirectChange: No table cells found');
      return;
    }

    config.tabList.forEach(k=>{
      k.setAttribute("tabindex","0")
      k.addEventListener('keydown', e => {
        handleDirectChange({
          ...config,
          e,
        })
      });
    })
  } catch (e) {
    logger.error('initDirectChange error:', e);
  }
}
